const SelectPagination = ({ limit, onLimitChange, label = 'Показывать по:' }) => {
  return (
    <label className={'text-gray-700 lg:absolute lg:text-base text-sm right-0 flex items-center justify-center gap-2'}>
      {label}
      <select
        className={'border text-center border-primary-300 rounded outline-none p-0.5 bg-white'}
        value={limit}
        onChange={(e) => onLimitChange(Number(e.target.value))}>
        {[10, 20, 50, 100].map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
    </label>
  );
};

export default SelectPagination;
